<template>
    <div class="d-flex justify-content-start">
        <core-number-range-input
            :label="$t('components.price.element.age.label')"
            :amountFrom.sync="initialAmountFrom"
            :amountUntil.sync="initialAmountUntil"
        ></core-number-range-input>
    </div>
</template>

<script>
export default {
  data () {
    return {
      initialAmountFrom: parseInt(this.amountFrom) || 0,
      initialAmountUntil: parseInt(this.amountUntil) || 0
    }
  },
  props: {
    amountFrom: {
      default: 0,
      type: String | Number,
      required: false
    },
    amountUntil: {
      default: 0,
      type: String | Number,
      required: false
    }
  },
  watch: {
    initialAmountFrom (val) {
      this.$emit('update:amountFrom', val)
    },
    initialAmountUntil (val) {
      this.$emit('update:amountUntil', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/element/Age.vue